import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { FormsModule, NgForm } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { MultiClickPreventionDirective } from '../event/multi-click-prevention.directive';
import { CountdownComponent, CountdownConfig, CountdownEvent } from 'ngx-countdown';

@Component({
  selector: 'ip-shared-document-signing',
  standalone: true,
  imports: [
    CommonModule,
    NgxExtendedPdfViewerModule,
    ButtonModule,
    RippleModule,
    FormsModule,
    InputTextModule,
    MultiClickPreventionDirective,
    CountdownComponent,
  ],
  templateUrl: 'document-signing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentSigningComponent implements OnInit {
  @Input({ required: true }) pdf!: string;
  @Input() otp: string | null = '';
  @Input() signText = '';
  @Input() signLabel = 'Semnează';
  @Input() retryLabel = 'Reîncearcă';
  @Input() passwordEntered = false;
  @Output() readonly loadPdf = new EventEmitter();
  @Output() readonly startSigning = new EventEmitter<string>();
  @Output() readonly signDocument = new EventEmitter<string>();

  readonly cntConfig: CountdownConfig = { leftTime: 60, formatDate: ({ date }) => `${date / 1000}` };
  password = '';
  signStarted = false;
  otpExpired = false;

  @ViewChild('passForm') private readonly passForm!: NgForm;
  @ViewChild('otpForm') private readonly otpForm!: NgForm;

  ngOnInit() {
    this.loadPdf.emit();
  }

  start() {
    if (this.otp && !this.otpExpired) {
      this.signDocument.emit(this.otp);
    } else {
      this.signStarted = true;
      if (this.passwordEntered || this.passForm.valid) {
        this.startSigning.emit(this.password);
        this.otpExpired = false;
        this.otp = '';
      }
    }
  }

  sign() {
    if (this.otpForm.valid && this.otp && !this.otpExpired) {
      this.signDocument.emit(this.otp);
    }
  }

  notify(e: CountdownEvent) {
    if (e.action === 'done') {
      this.otpExpired = true;
    }
  }
}
